import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiFactoryEndPoints } from '../common/api-factory-end-points';
import { State } from '../Model/state';
import { NameWithIdDto } from '../Model/name-with-id-dto';
import { WebOrderMinimumDateTimeSetup } from '../Model/web-order-minimum-date-time-setup';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AddressService {

  constructor(
    private apiFactory: ApiFactoryEndPoints,
    private http: HttpClient
  ) { }

  getStateList() {
    return this.http.get<State[]>(this.apiFactory.getStateList);
  }

  getDistrictByStateCode(url: string, stateCode: number) {
    return this.http.get<NameWithIdDto[]>(url + "/" + stateCode);
  }

  getWebOrderMinimumDateTimeDetails(currentUrl: string) {
    return this.http.get<WebOrderMinimumDateTimeSetup>(
      this.apiFactory.getWebOrderMinimumDateTimeDetails + "/" + currentUrl
    );
  }

  // getDeliveryDetails(url: string, email: string, pin: any) {
  //   return this.http.get<any>(url + "/" + email + "/" + pin);
  // }

  getDeliveryDetails(url: string, email: string) {
    return this.http.get<any>(url + "/" + email);
  }

  insertDeliveryDetails(url: string, req: any): Observable<any> {
    return this.http.post(url, req);
  }

  deactivateDeliveryDetails(url: string, refNo: number): Observable<any> {
    return this.http.delete(url + refNo, { responseType: 'text' as 'json' });
  }

  getCitysByDistrictCode(url: string, districtCode: number) {
    return this.http.get<NameWithIdDto[]>(url + "/" + districtCode);
  }

  getLocationByName(url: string, name: string) {
    return this.http.get<any>(url + "/" + name)
  }
}
